import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(filterList: any[], filterArgs: any, test: boolean): any {
    let newList: any[] = structuredClone(filterList)

    for (var key in filterArgs) {

      if (filterList&&filterList[0]&&filterList[0].hasOwnProperty(key)&&filterArgs[key]&&filterArgs[key].toString()) {

        
          newList = filterList.filter((item) => {
            let itemString = item[key].toString().toLowerCase()
            return itemString.includes(filterArgs[key].toString().toLowerCase())
          })
        

      }
    }

    return newList;
  }

}
